import Button from 'tailwind-components/Button/Button';
import CodeVerifier from '../CodeVerification/CodeVerifier';
import React, { useEffect, useState } from 'react';
import contryCodes from './contryCodes';
import images from 'constants/images';
import propTypes from 'prop-types';
import styles from './PhoneNumberInput.module.scss';
import useCodeSender from '../useCodeSender';

const recaptchaContainer = 'recaptcha-container';

const PhoneNumberInput = ({
  resolver = null,
  setVerificationId,
  setPhoneNumber: setPhoneNumberProp,
  newPhone = false,
  setResetMFA,
  /** When true, hide "Reset MFA" (e.g. change phone from /change-2fa-phone while logged in). */
  noReset = false
}) => {
  const hints = resolver?.hints ?? [];

  const {
    error,
    sendCode,
    verificationId,
    phoneNumber,
    setPhoneNumber,
    isLoading
  } = useCodeSender(recaptchaContainer, resolver);

  const [dialCode, setDialCode] = useState('+1');
  const [code, setCode] = useState(Array(10).fill(''));

  useEffect(() => {
    if (error === '' && verificationId !== '') {
      setVerificationId(verificationId);
      setPhoneNumberProp(phoneNumber);
    }
  }, [verificationId, phoneNumber]);

  return (
    <div className={newPhone ? {} : styles.login}>
      <form
        className={styles.formContainer}
        onSubmit={e => {
          e.preventDefault();
          setPhoneNumber(`${dialCode}${code.join('')}`);
          sendCode(`${dialCode}${code.join('')}`);
        }}
      >
        {!newPhone && (
          <>
            <img src={images.brand.fullLogo} alt={"O'Neill Logo"} />
            <p className={styles.subTitle}>{"O'Neill Host Portal Login"} </p>
          </>
        )}
        {error === '' && hints.length === 0 ? (
          <p className={styles.description}>
            {newPhone
              ? 'Enter the new phone number for 2FA'
              : 'Please enter your phone number to register for 2FA'}
          </p>
        ) : (
          <p className={styles.error}>{error}</p>
        )}
        {hints.length === 0 ? (
          <>
            <select
              style={{ width: '100%', marginBottom: '5%' }}
              onChange={e => {
                const newCode = e.target.value;
                const newDialCode = newCode.split('^')[1];
                setDialCode(newDialCode);
              }}
              defaultValue={'US^+1'}
            >
              {contryCodes.map(({ code, name, dial_code }) => {
                return (
                  <option key={code} value={`${code}^${dial_code}`}>
                    {name} {dial_code}
                  </option>
                );
              })}
            </select>
            <CodeVerifier
              type='phone'
              length={10}
              code={code}
              setCode={setCode}
              isLoading={false}
            />
          </>
        ) : (
          <p className={styles.description}>
            We will send a code to the number:
            <br />
            <strong>{hints.at(-1).phoneNumber}</strong>
          </p>
        )}
        <div
          style={{
            display: 'flex',
            marginTop: '5%',
            justifyContent: 'center',
            gap: '15px'
          }}
        >
          {resolver && !noReset && (
            <Button
              variant='danger'
              disabled={isLoading}
              text='Reset MFA'
              onClick={e => {
                e.preventDefault();
                setResetMFA(true);
              }}
            />
          )}
          <Button
            id={recaptchaContainer}
            type='submit'
            variant='primary'
            isLoading={isLoading}
            disabled={!resolver && code.some(digit => digit.trim() === '')}
            text={resolver ? 'Send SMS' : 'Send Verification Code'}
          />
        </div>
      </form>
    </div>
  );
};

PhoneNumberInput.propTypes = {
  resolver: propTypes.object,
  setVerificationId: propTypes.func,
  setPhoneNumber: propTypes.func,
  newPhone: propTypes.bool,
  setResetMFA: propTypes.func,
  noReset: propTypes.bool
};

export default PhoneNumberInput;
